import './index.scss'

import linkArrow from 'url:@icon/linkArrow.svg'
import eventPlaceholderImage from 'url:@assets/images/event-placeholder.png';

function formatDateRange(startISO?: string, endISO?: string, showTimes = true) {
  if (!startISO) return "";
  const start = new Date(startISO);
  const end = endISO ? new Date(endISO) : null;

  const options: Intl.DateTimeFormatOptions = showTimes ? {
    month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
  } : {
    month: 'short', day: 'numeric'
  };

  if (!end) return start.toLocaleString(undefined, options as any);

  // If same day, show range of times
  if (start.toDateString() === end.toDateString()) {
    const datePart = start.toLocaleDateString(undefined, { month: 'short', day: 'numeric' } as any);
    const startTime = start.toLocaleTimeString(undefined, { hour: 'numeric', minute: 'numeric' } as any);
    const endTime = end.toLocaleTimeString(undefined, { hour: 'numeric', minute: 'numeric' } as any);
    return `${datePart} • ${startTime} - ${endTime}`;
  }

  // Different days
  return `${start.toLocaleString(undefined, options as any)} - ${end.toLocaleString(undefined, options as any)}`;
}

export default function EventCard(props: {
  thumbnailURL: string | null;
  title: string;
  dateInfo: {
    startsAt: string;
    endsAt: string;
    showTimes: boolean;
  } | null,
  onClick: () => void;
}) {
  return <button className='event-card card' onClick={props.onClick}>
    <div className=''>
      <img src={props.thumbnailURL ? props.thumbnailURL : eventPlaceholderImage} className='thumbnail' alt={props.title} />
      <div className='content'>
        <div className='content-left'>
          <h3 className='title'>{props.title}</h3>
          {props.dateInfo ? <p className='date'>{formatDateRange(props.dateInfo.startsAt, props.dateInfo.endsAt, props.dateInfo.showTimes)}</p> : null}
        </div>
        <img src={linkArrow} alt="Open event" className="link-arrow" />
      </div>
    </div>
  </button>
}